import { customerCreateDescription as description } from './description';
import { addCustomer as execute } from './execute';

export { description, execute };
